import { render, staticRenderFns } from "./CriminalRecord.vue?vue&type=template&id=778f104f&scoped=true&"
import script from "./CriminalRecord.vue?vue&type=script&lang=ts&"
export * from "./CriminalRecord.vue?vue&type=script&lang=ts&"
import style0 from "./CriminalRecord.vue?vue&type=style&index=0&id=778f104f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f104f",
  null
  
)

export default component.exports